<template>
	<div>
		<apeiron-product-create
			v-bind="payload"
			v-if="['apeiron_uat', 'apeiron'].includes($store.state.tenantId)"
		/>
		<default-product-create v-else />
	</div>
</template>

<script>
import DefaultProductCreate from "../components/DefaultProductCreate"
import ApeironProductCreate from "../components/mockedApeiron/ApeironProductCreate"

export default {
	components: {
		DefaultProductCreate,
		ApeironProductCreate
	}
}
</script>
